import { forwardRef } from 'react';
import { twMerge } from 'tailwind-merge';

import { Colors, Sizes } from '@/components/ui/types';

import { LoadingProps, LoadingVariant } from './types';

const typeClasses: Record<LoadingVariant, string> = {
  spinner: 'loading-spinner',
  dots: 'loading-dots',
  ring: 'loading-ring',
  ball: 'loading-ball',
  bars: 'loading-bars',
  infinity: 'loading-infinity',
};

const sizeClasses: Record<Sizes, string> = {
  xs: 'loading-xs',
  sm: 'loading-sm',
  md: 'loading-md',
  lg: 'loading-lg',
  xl: 'loading-xl',
};

const colorClasses: Record<Colors, string> = {
  default: '',
  neutral: 'text-neutral',
  primary: 'text-primary',
  secondary: 'text-secondary',
  accent: 'text-accent',
  info: 'text-info',
  success: 'text-success',
  warning: 'text-warning',
  error: 'text-error',
};

export const Loading = forwardRef<HTMLSpanElement, LoadingProps>(
  (
    {
      className,
      variant: type = 'spinner',
      size = 'md',
      color = 'default',
      ...props
    },
    ref,
  ) => {
    const classes = twMerge(
      'loading',
      typeClasses[type],
      sizeClasses[size],
      colorClasses[color],
      className,
    );

    return <span ref={ref} className={classes} {...props} />;
  },
);

Loading.displayName = 'Loading';
